export default {
  title: 'Kies het pakket wat',
  title_light: ' het beste bij jou past!',
  subtitle: 'jouw aandelenoverdracht voor',
  description:
    'Bespaar tijd en geld door toegang tot 100+ op maat gemaakte juridische documenten en onbeperkt telefonsiche consultaties met gespecialiseerde advocaten'
};
